// IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ; «ожидаю что на всех элементах будет tooltip если навести с нажатым alt») — FE9: КАРТА ОБЪЯСНЕНИЙ по Alt для обзора согласования
// (вкладка «Approval» отчёта и виджет approval-overview страницы page-approval — components_core/ApprovalOverview.vue): карточки версий, прогресс и статусы, счётчики, шаги, кнопки действий,
// отборы, таблица «Хто кого очікує», события. Формат записи — как у прочих областей (utils/uiHelp.js): { title, what, why, click, now (states[state]), affects }.
// Тексты — английские литералы в t() (словари uk / ru — src/i18n/messages). Ключи 'approval.ov.<элемент>'; у статусов — 'approval.ov.status.<код>' и 'approval.ov.stepChip.<код>'.
// Проверка полноты (каждый v-uiHelp компонента имеет запись, все строки есть в uk / ru) — tests/unit/approvalOverview.test.mjs.
import { t } from '@/i18n'

const approvalOverview = {
    'approval.ov.refresh': () => ({
        title: t('Refresh'),
        what: t('Reads the approval overview from the server again.'),
        why: t('The statuses change while people work; the picture does not update itself.'),
        click: t('Click; the icon spins while the data is loading.'),
        affects: t('Nothing — reading only.'),
    }),
    'approval.ov.cardsHead': () => ({
        title: t('Segment · version'),
        what: t('The cards of the plans whose approval you can follow: one card for each pair «segment · plan version» with an approval cycle.'),
        why: t('Every version of a plan is approved on its own; here you pick the one to look at.'),
        click: t('Click a card — the same picture opens below.'),
    }),
    'approval.ov.card': () => ({
        title: t('Plan card'),
        what: t('Segment and version of a plan with the progress of its approval: the share of completed steps, overdue units, the number of units and drafts, the nearest due date.'),
        why: t('To compare the plans at a glance and see where something is stuck.'),
        click: t('Click to show this plan below; the shown card has a thick border.'),
        affects: t('Only what is shown below; no data is changed.'),
        states: { on: t('This card is shown below.'), off: t('Click to show this plan below.') },
    }),
    'approval.ov.cardSeg': () => ({
        title: t('Segment'),
        what: t('The segment (the kind of plan) this approval cycle belongs to.'),
        click: t('Click the card to show it below.'),
    }),
    'approval.ov.cardVer': () => ({
        title: t('Plan version'),
        what: t('The version of the plan whose approval the card follows; every version has its own cycle, units and due dates.'),
        click: t('Click the card to show it below.'),
    }),
    'approval.ov.cardBar': () => ({
        title: t('Progress strip'),
        what: t('The units of the plan by status: green — approved, orange — approved with changes, yellow — in review, grey — draft, hatched — waiting for the lower step, red — returned.'),
        affects: t('Nothing — reading only.'),
    }),
    'approval.ov.cardPct': () => ({
        title: t('Completed, %'),
        what: t('The share of the unit-steps that are completed (approved, approved with changes, skipped or frozen) out of all unit-steps of the version; cancelled ones are not counted.'),
        why: t('One number for «how far is this plan from the end of the approval».'),
    }),
    'approval.ov.cardOverdue': () => ({
        title: t('Overdue'),
        what: t('The number of units that are not approved yet and whose due date is earlier than today.'),
        why: t('Shows the plans that are late.'),
        click: t('Click the card, then the red counter or a person in the table opens the monitor of the late units.'),
    }),
    'approval.ov.cardUnits': () => ({
        title: t('Units · drafts'),
        what: t('How many approval units the plan has in total (units of all steps) and how many of them are still drafts.'),
        why: t('A draft is not submitted yet — nobody can approve it.'),
    }),
    'approval.ov.cardNearest': () => ({
        title: t('Nearest due date'),
        what: t('The earliest due date among the units that are not approved yet.'),
        why: t('Tells how much time is left before the first deadline.'),
    }),
    'approval.ov.selHead': () => ({
        title: t('Shown plan'),
        what: t('The segment and the version of the plan the whole picture below belongs to.'),
    }),
    'approval.ov.progTitle': () => ({
        title: t('Version progress'),
        what: t('How many approval units the version has and how many steps the approval process has. Every unit goes through every step.'),
        why: t('The plan is approved unit by unit (for example brand → business unit → all).'),
        states: { all: t('Scope: the whole version.'), scoped: t('Scope: {scope}. The numbers cover only the units of this selection.') },   // IE 2026 10 13 / ODOO-5800
    }),
    'approval.ov.progDone': () => ({
        title: t('Completed'),
        what: t('The unit-steps that are completed: approved, approved with changes, skipped or frozen. The percent is this number out of all unit-steps of the version without the cancelled ones.'),
        affects: t('Nothing — reading only.'),
    }),
    'approval.ov.bar': () => ({
        title: t('Progress strip of the version'),
        what: t('All units of the version by status, in the order: done → in work → waiting. The width of a part is the share of the units in that status.'),
        why: t('To see at once how much is done and what blocks the rest.'),
        affects: t('Nothing — reading only.'),
    }),
    'approval.ov.status.approved': () => ({
        title: t('Approved'),
        what: t('The unit passed the step and was approved; its data is locked. Counts as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.approved': () => ({
        title: t('Approved'),
        what: t('The unit passed the step and was approved; its data is locked. Counts as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.approved_changed': () => ({
        title: t('Approved, with changes'),
        what: t('The unit was approved and then its data was changed; the preparer has to submit it again. Counts as completed in the progress until then.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.approved_changed': () => ({
        title: t('Approved, with changes'),
        what: t('The unit was approved and then its data was changed; the preparer has to submit it again. Counts as completed in the progress until then.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.skipped': () => ({
        title: t('Skipped'),
        what: t('An optional step that was closed without approval, with a comment. Counts as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.skipped': () => ({
        title: t('Skipped'),
        what: t('An optional step that was closed without approval, with a comment. Counts as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.frozen': () => ({
        title: t('Frozen'),
        what: t('The cycle was closed: the approved data is frozen for good. Counts as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.frozen': () => ({
        title: t('Frozen'),
        what: t('The cycle was closed: the approved data is frozen for good. Counts as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.review': () => ({
        title: t('In review'),
        what: t('The unit is submitted and waits for the approver of the step. This is the status that becomes overdue when the due date passes.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.review': () => ({
        title: t('In review'),
        what: t('The unit is submitted and waits for the approver of the step. This is the status that becomes overdue when the due date passes.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.returned': () => ({
        title: t('Returned'),
        what: t('The approver returned the unit with a comment; the preparer fixes the data and submits it again. Not counted as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.returned': () => ({
        title: t('Returned'),
        what: t('The approver returned the unit with a comment; the preparer fixes the data and submits it again. Not counted as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.draft': () => ({
        title: t('Draft'),
        what: t('The preparer is still working on the unit; it is not submitted, nobody can approve it. Not counted as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.draft': () => ({
        title: t('Draft'),
        what: t('The preparer is still working on the unit; it is not submitted, nobody can approve it. Not counted as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.waiting': () => ({
        title: t('Waiting'),
        what: t('The unit has not reached this step: the step below is not finished yet. Not counted as completed.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.waiting': () => ({
        title: t('Waiting'),
        what: t('The unit has not reached this step: the step below is not finished yet. Not counted as completed.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.cancelled': () => ({
        title: t('Cancelled'),
        what: t('The unit left the cycle; it is not counted in the progress at all.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.cancelled': () => ({
        title: t('Cancelled'),
        what: t('The unit left the cycle; it is not counted in the progress at all.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.status.other': () => ({
        title: t('Status'),
        what: t('The status of an approval unit.'),
        states: { count: t('{n} unit(s) in this status, {pct} % of the version.') },
    }),
    'approval.ov.stepChip.other': () => ({
        title: t('Status'),
        what: t('The status of an approval unit.'),
        why: t('Shows how many units of this step are in this status.'),
        click: t('Click: the approval monitor opens with this step and this status.'),
        states: { count: t('{n} unit(s) of the step.') },
    }),
    'approval.ov.kpiOverdue': () => ({
        title: t('Overdue'),
        what: t('Units that are not approved yet and whose due date is earlier than today (due_at < today). Approved, skipped, frozen and cancelled units are never overdue.'),
        why: t('Shows how many units are late and need a push.'),
        click: t('Pick «only overdue» in the selection to act on them; the table «Who waits for whom» shows who is late.'),
    }),
    'approval.ov.kpiSoon': () => ({
        title: t('Due soon (≤ 3 days)'),
        what: t('Units that are not approved yet and whose due date is today or within the next 3 days (not overdue yet).'),
        why: t('An early warning: these units become overdue if nothing is done.'),
    }),
    'approval.ov.kpiNearest': () => ({
        title: t('Nearest due date'),
        what: t('The earliest due date among the units that are not approved yet.'),
    }),
    'approval.ov.kpiMe': () => ({
        title: t('Waiting for me'),
        what: t('Units in review where you are the responsible person or one of the approvers of the step: it is your move.'),
        why: t('Your inbox as an approver: what to look at first.'),
        click: t('Use the step buttons «Approve what waits for me» / «Return…» to act on them.'),
    }),
    'approval.ov.kpiMyDrafts': () => ({
        title: t('My drafts'),
        what: t('Units that you prepare and that are drafts, returned to you or approved and changed afterwards: they wait for your submit.'),
        click: t('Use the step button «Submit my drafts».'),
    }),
    'approval.ov.job': () => ({
        title: t('Background action'),
        what: t('The progress of a bulk action over more than 300 units: it runs on the server in the background; «done / total» counts the units processed.'),
        affects: t('The overview is read again when it ends.'),
    }),
    'approval.ov.result': () => ({
        title: t('Result of the action'),
        what: t('What the last bulk action did: how many units were done out of the total, and the first reasons why some were skipped.'),
        affects: t('Nothing — reading only.'),
    }),
    'approval.ov.error': () => ({
        title: t('Error'),
        what: t('The server could not build the overview of this version; the text is the reason it gave.'),
    }),
    'approval.ov.procTitle': () => ({
        title: t('Approval business process'),
        what: t('The steps of the approval by the policy of the segment: the chevrons show the steps and their progress, the cards below show who prepares, who approves and what can be done.'),
    }),
    'approval.ov.procSel': () => ({
        title: t('Selection for actions'),
        what: t('Which units the step buttons below act on, and the user the overview is built for.'),
        why: t('The same buttons can act on all units, on the rows of the report, on the selected rows or only on yours.'),
        click: t('Change it with the chips «Selection» below.'),
    }),
    'approval.ov.chev': () => ({
        title: t('Step'),
        what: t('A step of the approval chain: its number, the title and the share of its units that have completed it.'),
        why: t('The plan goes through the steps from the first to the last; the last one is the final approval.'),
        click: t('Click: the approval monitor opens with the units of this step.'),
        states: { mine: t('This is your step: there is something for you to do at it.'), other: t('You have nothing to do at this step now.') },
    }),
    'approval.ov.chevNum': () => ({
        title: t('Step number'),
        what: t('The order of the step in the chain; the units go from step 1 upwards.'),
        click: t('Click: the monitor of this step.'),
    }),
    'approval.ov.chevPct': () => ({
        title: t('Step progress, %'),
        what: t('The share of the units that completed this step (approved, approved with changes, skipped or frozen) out of all units of the step.'),
        click: t('Click: the monitor of this step.'),
    }),
    'approval.ov.myBadge': () => ({
        title: t('My step'),
        what: t('The mark of a step where you have a move: units waiting for your approval, or your drafts and returned units to submit.'),
        why: t('To find your work among the steps at once.'),
    }),
    'approval.ov.step': () => ({
        title: t('Step card'),
        what: t('Everything about one step: the statuses of its units, who prepares and approves, who is responsible now, the due dates, and the bulk action buttons.'),
        affects: t('Nothing — reading only.'),
        states: { mine: t('The card has a thick border: this is your step.') },
    }),
    'approval.ov.prepares': () => ({
        title: t('Prepares'),
        what: t('The role whose holders prepare the data of the unit at this step and submit it for approval.'),
        why: t('Only the holders of this role can submit the drafts of the step.'),
    }),
    'approval.ov.approves': () => ({
        title: t('Approves'),
        what: t('The role whose holders approve or return the units at this step.'),
        why: t('Only the holders of this role can approve or return the units of the step.'),
    }),
    'approval.ov.optional': () => ({
        title: t('Optional step'),
        what: t('The step may be skipped for a unit with a comment; the process then goes on with the next step.'),
    }),
    'approval.ov.responsible': () => ({
        title: t('Responsible'),
        what: t('The person who has the most units waiting at this step (the units the person is responsible for), with the others behind «more». When the units have not reached the people yet, the line shows the holders of the approver role and is named «Approvers».'),
        why: t('Tells whom to ask when the step is stuck.'),
        states: { people: t('Now: the people who hold the units of the step.'), role: t('Now: the holders of the approver role — the units have not reached the people yet.') },
    }),
    'approval.ov.person': () => ({
        title: t('Person'),
        what: t('A user taking part in the approval; the name is the record of the user in the USER segment.'),
        states: { link: t('Click opens the USER record of this person.'), plain: t('No USER record for this person (a system action or an address without a user): nothing to open.'), plainTip: t('No USER record for this person; the address is {tip}.') },
    }),
    'approval.ov.more': () => ({
        title: t('More people'),
        what: t('The number of other people (or role holders) who also hold the units of this step.'),
        click: t('Click shows or hides their names.'),
    }),
    'approval.ov.stepDue': () => ({
        title: t('Due'),
        what: t('The due dates of the units of this step: the nearest one, how many units are overdue (due date is earlier than today) and how many are due soon (today or within 3 days).'),
        why: t('A due date comes from the policy; an administrator can move it for one unit.'),
    }),
    'approval.ov.stepDueOverdue': () => ({
        title: t('Overdue at the step'),
        what: t('Units of this step that are not approved and whose due date is earlier than today.'),
    }),
    'approval.ov.stepDueSoon': () => ({
        title: t('Due soon at the step'),
        what: t('Units of this step that are not approved and whose due date is today or within the next 3 days.'),
    }),
    'approval.ov.waitsLower': () => ({
        title: t('Waits for the step below'),
        what: t('All units of this step are waiting: the step below has to finish first, nothing can be done here yet.'),
    }),
    'approval.ov.finalStep': () => ({
        title: t('Final step'),
        what: t('The last step of the chain: when all its units are approved, the whole plan is approved. «approved X of Y» counts them.'),
    }),
    'approval.ov.acts': () => ({
        title: t('Bulk actions of the step'),
        what: t('The buttons that act on many units of this step at once, in the selection chosen below. The number in brackets is how many units the button will touch.'),
        why: t('Instead of opening the units one by one.'),
        click: t('Click a button; a window asks for the comment where it is needed.'),
    }),
    'approval.ov.act.submit': () => ({
        title: t('Submit'),
        what: t('Sends the drafts of this step to the approver. «my drafts» are the units you prepare; an administrator can submit «on behalf» of the preparers.'),
        why: t('The approver gets the units to check; the data of a submitted unit is locked.'),
        click: t('Click: a window shows what will be done to how many units and asks for the comment where needed; units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.'),
        affects: t('Draft / Returned → In review for the units of this step in the selection.'),
        states: { mine: t('Acts on your units of this step: {n}.'), behalf: t('You act as an administrator on behalf of the role of the step: {n} unit(s); a comment is mandatory and the history marks the action as done on behalf.'), all: t('Acts on the units of this step in the selection: {n}.'), off: t('Not available now: {reason}.') },
    }),
    'approval.ov.act.approve': () => ({
        title: t('Approve'),
        what: t('Approves the units of this step that wait for you. «on behalf» lets an administrator approve for the approver.'),
        why: t('The next step gets the units only when the ones below are approved.'),
        click: t('Click: a window shows what will be done to how many units and asks for the comment where needed; units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.'),
        affects: t('In review → Approved; the data of the units is locked for everybody.'),
        states: { mine: t('Acts on your units of this step: {n}.'), behalf: t('You act as an administrator on behalf of the role of the step: {n} unit(s); a comment is mandatory and the history marks the action as done on behalf.'), all: t('Acts on the units of this step in the selection: {n}.'), off: t('Not available now: {reason}.') },
    }),
    'approval.ov.act.return': () => ({
        title: t('Return'),
        what: t('Returns the units of this step to the preparer with a mandatory comment and a reason category.'),
        why: t('The preparer sees why and fixes the data.'),
        click: t('Click: a window shows what will be done to how many units and asks for the comment where needed; units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.'),
        affects: t('In review → Returned; the preparer can edit the data again.'),
        states: { mine: t('Acts on your units of this step: {n}.'), behalf: t('You act as an administrator on behalf of the role of the step: {n} unit(s); a comment is mandatory and the history marks the action as done on behalf.'), all: t('Acts on the units of this step in the selection: {n}.'), off: t('Not available now: {reason}.') },
    }),
    'approval.ov.act.recall': () => ({
        title: t('Recall'),
        what: t('Takes the submitted units of this step back from the approver while he has not acted yet; the rights are checked by the server for every unit.'),
        why: t('To fix something after the submit without waiting for a return.'),
        click: t('Click: a window shows what will be done to how many units and asks for the comment where needed; units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.'),
        affects: t('In review → Draft; the lock of the preparer is lifted.'),
        states: { mine: t('Acts on your units of this step: {n}.'), behalf: t('You act as an administrator on behalf of the role of the step: {n} unit(s); a comment is mandatory and the history marks the action as done on behalf.'), all: t('Acts on the units of this step in the selection: {n}.'), off: t('Not available now: {reason}.') },
    }),
    'approval.ov.act.reopen': () => ({
        title: t('Reopen'),
        what: t('Opens the approved units of this step for changes again; administrators only, with a mandatory reason.'),
        why: t('Approved data is locked for everybody; this is the only way to change it.'),
        click: t('Click: a window shows what will be done to how many units and asks for the comment where needed; units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.'),
        affects: t('Approved → Returned; the approved parents wait for the unit again; the history is kept.'),
        states: { mine: t('Acts on your units of this step: {n}.'), behalf: t('You act as an administrator on behalf of the role of the step: {n} unit(s); a comment is mandatory and the history marks the action as done on behalf.'), all: t('Acts on the units of this step in the selection: {n}.'), off: t('Not available now: {reason}.') },
    }),
    'approval.ov.filterLabel': () => ({
        title: t('Selection'),
        what: t('Which units the step buttons act on and which units the overview counts.'),
        why: t('The same buttons work on the whole version or on a small part of it.'),
        click: t('Click one of the chips; the overview is read again for the selection.'),
    }),
    'approval.ov.filter.all': () => ({
        title: t('All units of the version'),
        what: t('The overview and the buttons work with every unit of the plan version.'),
        affects: t('The counters, the table «Who waits for whom» and the step buttons («Submit», «Approve», «Return», «Recall», «Reopen») work with this selection only.'),
        states: { on: t('Selected now.'), off: t('Click to select.') },
    }),
    'approval.ov.filter.rows': () => ({
        title: t('Rows of the report'),
        what: t('Only the units of the rows of this report (all rows, also those collapsed in groups).'),
        why: t('Approve or return exactly what the report shows.'),
        click: t('If the report has no rows with approval units, the buttons are disabled.'),
        affects: t('The counters, the table «Who waits for whom» and the step buttons («Submit», «Approve», «Return», «Recall», «Reopen») work with this selection only.'),
        states: { on: t('Selected now.'), off: t('Click to select.') },
    }),
    'approval.ov.filter.selected': () => ({
        title: t('Selected rows'),
        what: t('Only the units of the rows selected in the table of the report.'),
        why: t('Act on a few rows without touching the rest.'),
        click: t('Select rows in the table first, otherwise the buttons are disabled.'),
        affects: t('The counters, the table «Who waits for whom» and the step buttons («Submit», «Approve», «Return», «Recall», «Reopen») work with this selection only.'),
        states: { on: t('Selected now.'), off: t('Click to select.') },
    }),
    'approval.ov.filter.mine': () => ({
        title: t('Only mine'),
        what: t('Only the units where you are the responsible person, the approver or the preparer.'),
        why: t('Your own work without the rest of the plan.'),
        affects: t('The counters, the table «Who waits for whom» and the step buttons («Submit», «Approve», «Return», «Recall», «Reopen») work with this selection only.'),
        states: { on: t('Selected now.'), off: t('Click to select.') },
    }),
    'approval.ov.filter.overdue': () => ({
        title: t('Only overdue'),
        what: t('Only the units whose due date is earlier than today and that are not approved.'),
        why: t('To push exactly the late work.'),
        affects: t('The counters, the table «Who waits for whom» and the step buttons («Submit», «Approve», «Return», «Recall», «Reopen») work with this selection only.'),
        states: { on: t('Selected now.'), off: t('Click to select.') },
    }),
    'approval.ov.filterHint': () => ({
        title: t('Size of the action'),
        what: t('A reminder: the action applies to the selection; more than 300 units run in the background with a progress indicator.'),
    }),
    'approval.ov.waitHead': () => ({
        title: t('Who waits for whom'),
        what: t('The people the units are waiting for, by the snapshot of approvers and preparers: how many units each person holds at which step, and how many of them are overdue.'),
        why: t('To see at once who holds the plan up.'),
        click: t('Click a row: the monitor of this person opens.'),
    }),
    'approval.ov.th.responsible': () => ({
        title: t('Responsible'),
        what: t('The person whose move it is: the units where this person is the responsible one.'),
        click: t('Column of the table «Who waits for whom».'),
    }),
    'approval.ov.th.step': () => ({
        title: t('Step'),
        what: t('The steps at which this person holds units: number and title.'),
        click: t('Column of the table «Who waits for whom».'),
    }),
    'approval.ov.th.units': () => ({
        title: t('Units'),
        what: t('How many units the person is responsible for (waits for the move of this person).'),
        click: t('Column of the table «Who waits for whom».'),
    }),
    'approval.ov.th.overdue': () => ({
        title: t('Overdue'),
        what: t('How many of these units are overdue: due date earlier than today.'),
        click: t('Column of the table «Who waits for whom».'),
    }),
    'approval.ov.th.also': () => ({
        title: t('Also can act'),
        what: t('The units where the person is not the responsible one but may act along with the responsible (the same role).'),
        click: t('Column of the table «Who waits for whom».'),
    }),
    'approval.ov.waitRow': () => ({
        title: t('Person row'),
        what: t('One person (or the system) with the units that wait for the person: steps, units, overdue, and units the person can also act on.'),
        click: t('Click: the approval monitor opens with the units of this person.'),
        states: { me: t('This is you.'), noUser: t('A person without a USER record: the click opens the monitor of the step.') },
    }),
    'approval.ov.waitStep': () => ({
        title: t('Step of the person'),
        what: t('A step at which this person holds units.'),
        click: t('Click: the monitor with this person and this step.'),
    }),
    'approval.ov.waitUnits': () => ({
        title: t('Units of the person'),
        what: t('The units the person is responsible for.'),
    }),
    'approval.ov.waitOverdue': () => ({
        title: t('Overdue of the person'),
        what: t('How many units of the person are overdue: not approved and the due date is earlier than today.'),
    }),
    'approval.ov.waitAlso': () => ({
        title: t('Also can act'),
        what: t('Units where the person may act along with the responsible one but is not the responsible one.'),
    }),
    'approval.ov.waitEmpty': () => ({
        title: t('Nobody is waited for'),
        what: t('In this selection no unit waits for anybody: nothing is in review or in draft.'),
    }),
    'approval.ov.waitMore': () => ({
        title: t('More people'),
        what: t('The table shows the first people only; the rest are hidden.'),
        click: t('Click shows all of them.'),
    }),
    'approval.ov.waitMoreSrv': () => ({
        title: t('More people on the server'),
        what: t('The server sent only the first people of the table; the rest are not loaded here.'),
    }),
    'approval.ov.waitNote': () => ({
        title: t('How to read the columns'),
        what: t('«Units» — where the person is responsible; «Also can act» — where the person may act along with the responsible one.'),
    }),
    'approval.ov.evHead': () => ({
        title: t('Recent events'),
        what: t('The latest events of the approval of this version, newest first; the number is how many events were loaded.'),
        why: t('To see what happened lately without opening the history of every unit.'),
    }),
    'approval.ov.ev': () => ({
        title: t('Event'),
        what: t('One event of an approval unit: when, who, what was done, the change of the status, the step, the comment and the unit.'),
        why: t('The history of events is immutable — it shows who approved what.'),
        click: t('Click the unit name below the event to open the approval unit with its history.'),
    }),
    'approval.ov.evAt': () => ({
        title: t('When'),
        what: t('The time of the event, in your time zone.'),
        states: { tip: t('Exact time: {at}') },
    }),
    'approval.ov.evAction': () => ({
        title: t('Action'),
        what: t('What was done with the unit: submit, approve, return, recall, reopen, skip and so on.'),
    }),
    'approval.ov.evOnBehalf': () => ({
        title: t('On behalf'),
        what: t('The action was done by an administrator on behalf of the role of the step, with a mandatory comment.'),
    }),
    'approval.ov.evChange': () => ({
        title: t('Change of the status'),
        what: t('The status of the unit before → after the event.'),
    }),
    'approval.ov.evStep': () => ({
        title: t('Step of the event'),
        what: t('The number of the step of the approval chain the event belongs to.'),
    }),
    'approval.ov.evComment': () => ({
        title: t('Comment'),
        what: t('The comment the person wrote with the action (mandatory for return, reopen, skip and every action on behalf).'),
    }),
    'approval.ov.evUnit': () => ({
        title: t('Approval unit'),
        what: t('The unit the event belongs to: the dimensions of the plan it covers.'),
        why: t('Opens the full history of this unit.'),
        click: t('Click opens the record of the approval unit with its history.'),
        states: { link: t('Click opens the record of the unit.'), plain: t('The record of the unit cannot be opened from here.') },
    }),
    'approval.ov.evEmpty': () => ({
        title: t('No events yet'),
        what: t('Nothing has happened in the approval of this version yet.'),
    }),
    'approval.ov.evMore': () => ({
        title: t('More events'),
        what: t('The list shows the latest events only.'),
        click: t('Click shows all the events.'),
    }),
    'approval.ov.updated': () => ({
        title: t('Updated'),
        what: t('The time the overview was built on the server; it does not refresh itself while the tab is open.'),
        click: t('Use «Refresh» to read it again.'),
    }),
    'approval.ov.empty': () => ({
        title: t('Overview not available'),
        what: t('The text says why there is nothing to show: the data is loading, there is no approval cycle yet, or the overview is switched off.'),
    }),
    'approval.ov.root': () => ({
        title: t('Approval overview'),
        what: t('The picture of the approval of one plan version: progress, the steps of the process with who prepares and approves, the bulk actions, the selection of units, who waits for whom and the latest events.'),
        why: t('One place to see where each unit of the plan is stuck and to move it on.'),
        click: t('Hold Alt over any element of the picture to read what it is; click the counters, pills, steps and people to open the monitor.'),
    }),
    'approval.ov.filterBar': () => ({
        title: t('Selection of units'),
        what: t('The row of chips that choose which units of the version the overview counts and the step buttons act on: all units, the rows of the report, the selected rows, only yours, only overdue.'),
        why: t('The same buttons work on the whole version or on a small part of it.'),
        click: t('Click a chip; the overview is read again for that selection.'),
    }),
}
export default approvalOverview
